import { USA_FORM_STEPS } from '.';

export const STAGE_STEPS = {
  BANK_INFORMATION: 'account',
  DOCUMENTS: 'documents',
  IDENTIFICATION_OFFICIAL: 'final_questions',
};

export const FORM_STEP_FIELDS = {
  [USA_FORM_STEPS.BANK_INFORMATION]: STAGE_STEPS.BANK_INFORMATION,
  [USA_FORM_STEPS.COMPANY_DOCUMENTATION]: STAGE_STEPS.DOCUMENTS,
  [USA_FORM_STEPS.IDENTIFICATION_OFFICIAL]: STAGE_STEPS.IDENTIFICATION_OFFICIAL,
};
